import { Controller } from "@hotwired/stimulus"

// Landing partner — modal de reproducción de la sección Demos.
// Overlay propio (sin Bootstrap). Al abrir carga el <video> con la URL del blob
// (ActiveStorage → S3) y lo reproduce; al cerrar pausa, limpia el src y libera scroll.
export default class extends Controller {
  static targets = ["modal", "video", "title"]

  open(event) {
    const { src, poster, title } = event.params
    if (!src) return

    if (this.hasTitleTarget) this.titleTarget.textContent = title || ""
    if (this.hasVideoTarget) {
      if (poster) this.videoTarget.poster = poster
      this.videoTarget.src = src
    }

    this.modalTarget.hidden = false
    document.body.style.overflow = "hidden"
    if (this.hasVideoTarget) {
      const p = this.videoTarget.play()
      if (p && p.catch) p.catch(() => {}) // ignora AbortError si cierran rápido
    }
  }

  close() {
    if (this.modalTarget.hidden) return
    this.modalTarget.hidden = true
    document.body.style.overflow = ""
    if (this.hasVideoTarget) {
      this.videoTarget.pause()
      this.videoTarget.removeAttribute("src")
      this.videoTarget.load() // descarga el buffer
    }
  }

  closeOnBackdrop(event) {
    if (event.target === this.modalTarget) this.close()
  }

  disconnect() {
    document.body.style.overflow = ""
  }
}
